import {
  REQUEST_SNCR_NUMEROS,
  RECEIVE_SNCR_NUMEROS,
} from '../constants/ActionTypes'

const INITIAL_STATE = {
  numeros: {
    isLoading: false,
    params: {},
    data: {
      rows: [],
      count: 0,
      page: 1,
      limit: 50,
    },
  },
}

export default function sncrReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_SNCR_NUMEROS:
      return {
        ...state,
        numeros: {
          isLoading: action.isLoading,
          params: action.params,
          data: INITIAL_STATE.numeros.data,
        },
      }
    case RECEIVE_SNCR_NUMEROS:
      return {
        ...state,
        numeros: {
          isLoading: action.isLoading,
          params: state.numeros.params,
          data: action.data,
          receivedAt: action.receivedAt,
        },
      }
    default:
      return state
  }
}
